import axiosClient from "utils/api";
const URI = "/admin/securityQuestions";
// For get All Sequrity Question
export const getSequrityQuestion = async (payload) => {
  try {
    const res = await axiosClient().request({
      url: URI,
      method: "get",
      params: payload,
    });

    return res.data;
  } catch (error) {
    console.error("Error occuured Get All Sequrity Question:", error.message);
    throw error;
  }
};

// For Add Sequrity Question
export const addSequrityQuestion = async (payload) => {
  try {
    const res = await axiosClient().request({
      url: URI,
      method: "post",
      data: payload,
    });
    return res.data;
  } catch (error) {
    console.error("Error Occurred Add Sequrity Question:", error.message);
    throw error;
  }
};

// For Update Sequrity Question
export const updateSequrityQuestion = async (payload) => {
  let { id, ...rest } = payload;
  try {
    const res = await axiosClient().request({
      url: `${URI}/${id}`,
      method: "put",
      data: rest,
    });
    return res.data;
  } catch (error) {
    console.error("Error Occurred Update Sequrity Question:", error.message);
    throw error;
  }
};

// For Delete Sequrity Question
export const deleteSequrityQuestion = async (payload) => {
  try {
    const res = await axiosClient().request({
      url: `${URI}/${payload.id}`,
      method: "delete",
    });
    return res.data;
  } catch (error) {
    console.error("Error Occurred Delete Sequrity Question:", error.message);
    throw error;
  }
};
